<template>
  <button
    :class="['bubble -returnToTop', { '-visible': scrollPosition > 500 }]"
    @click.stop="$router.push({ ...$route, hash: '' })"
  >
    <Icon id="next" class="arrow" />
    <span>Retour en haut</span>
  </button>
</template>

<script>
import Icon from '@/components/global/Icon.vue'

export default {
  name: 'ReturnToTop',
  components: { Icon },
  data() {
    return {
      scrollPosition: 0,
    }
  },
  methods: {
    setScrollPosition() {
      this.$nextTick(() => {
        this.scrollPosition = window.scrollY || window.pageYOffset
      })
    },
  },
  mounted() {
    window.addEventListener('scroll', this.setScrollPosition, { passive: true })
  },
}
</script>
